// fidelidade farmacia 15%
// saude e vida 60%

// thenail
// - fidelidade 15%
// yalo/loja
// - saude, fidelidade e vida 60%
// marisa
// -fidelidade com carencia e sem (só dr.consulta)
// brasiladm
// - fidelidade com o clube de descontos pag volta e seguro

// fazer um trabalho de mocar informações de cada loja em algum arquivo estilo um enum de lojas;

// observando as propriedades de beneficios, tipos de produtos, produtos;

// store 1 - N plans
// plan 1 - N benefits
// plan possui property type

// todos os beneficios
export const benefits = {
	1: 'Descontos em Farmácias 15%',
	2: '<strong>Consultas online</strong> por R$ 40,00',
	3: '<strong>Droga Raia</strong> e <strong> Drogasil</strong> com até 60% de desconto',
	4: '<strong>Consultas presenciais</strong> por R$ 40,00',
	5: '<strong>Exames</strong> com 20% de desconto',
	// 4: 'Novas especialidades: especial coronavírus, psicologia e psiquiatria',
	6: '<strong>SmartFit</strong> por R$ 39,90/mês',
	7: 'Cartão físico pré-pago <strong>yalo</strong>'
};

export const benefitsIndividual = {
	1: 'Descontos em Farmácias 15%',
	2: '<strong>Consultas online</strong> por R$ 40,00',
	3: '<strong>Droga Raia</strong> e <strong> Drogasil</strong> com até 15% de desconto',
	4: '<strong>Consultas presenciais</strong> por R$ 40,00',
	5: '<strong>Exames</strong> com 20% de desconto',
	// 4: 'Novas especialidades: especial coronavírus, psicologia e psiquiatria',
	6: '<strong>Clube de Desconto</strong>',
	7: '<strong>Seguro de vida</strong> e sorteio mensais'
};

export const benefitsTipsIndividual = {
	1: '',
	2: 'Consultas relacionadas ao coronavírus além de psicologia, psiquiatria e muitas outras especialidades. Todas consultas online de R$ 90 por R$ 40, ilimitadas e com retorno gratuito em até 30 dias.',
	3: '15% de descontos em medicamentos genéricos, tarjados e de marca, em toda rede Droga Raia e Drogasil',
	4: 'Consultas presenciais de R$ 120, na média, por R$ 40, incluindo coronavírus, psicologia, psiquiatria e mais de 40 especialidades médicas. Consultas ilimitadas e com retorno gratuito em até 30 dias.',
	5: 'Mais de 3000 exames realizados nos próprios centros médicos do dr.consulta, incluindo ressonância magnética, tomografia, ultrassonografia, raio-x, dentre outros.',
	6: 'Descontos em mais de 200 lojas, de diversos segmentos, como cinemas, eletrônicos,lazer, entre outros.',
	7: 'Seguro de Vida, Invalidez Permanente por Acidente, Auxílio Funeral e sorteios mensais de R$5.000,00'
};

export const benefitsTips = {
	1: '',
	2: 'Consultas relacionadas ao coronavírus além de psicologia, psiquiatria e muitas outras especialidades. Todas consultas online de R$ 90 por R$ 40, ilimitadas e com retorno gratuito em até 30 dias.',
	3: '<strong>Genéricos</strong><br/>60% tarjado; 35% sem tarja. <br/><strong>Medicamentos de marca</strong><br/> 25% em tarjados; 10% sem tarja<br/><strong>Desconto em perfumaria</strong><br/> 5% em toda a loja',
	4: 'Consultas presenciais de R$ 120, na média, por R$ 40, incluindo coronavírus, psicologia, psiquiatria e mais de 40 especialidades médicas. Consultas ilimitadas e com retorno gratuito em até 30 dias.',
	5: 'Mais de 3000 exames realizados nos próprios centros médicos do dr.consulta, incluindo ressonância magnética, tomografia, ultrassonografia, raio-x, dentre outros.',
	6: 'Plano nacional de R$ 99,90 por R$ 39,90/mes significando um desconto de R$60,00 todos os meses para uso da Smart Fit. Sem fidelidade de 12 meses, sem multa de cancelamento, sem taxa de manutenção e sem taxa de adesão.',
	7: ''
};

// beneficios para mostrar na tabela
export const benefitsTable = [2, 3, 4, 5, 6];
export const benefitsTableIndividual = [2, 3, 4, 5, 6, 7];
export const benefitsTableFrete = [2, 3];
export const benefitsTableEMED = [2];
export const benefitsTableFidelidade = [2, 3, 5];
export const benefitsTableTheNail = [2, 3, 7, 8];

// colunas keys e beneficios se sim e pertencente ao benefitsTable certinho na tabela
// se clicar no em uma das colunas leva o key para filtrar os planos
export const plansYalo = {
	'YALO Vida': { benefits: [2, 3] },
	'YALO Fidelidade': { benefits: [2, 4, 5] },
	'YALO Saude': { benefits: [2, 3, 4, 5, 6, 7] }
};
export const plansIndividual = {
	'YALO Individual': { benefits: [2, 3, 4, 5, 6, 7] }
};

export const plansCargox = {
	'YALO Vida': { benefits: [2, 3] }
	// 'YALO Fidelidade': { benefits: [2, 4, 5] },
	// 'YALO Saude': { benefits: [2, 3, 4, 5, 6, 7] }
};

export const plansEMED = {
	'YALO e-MED': { benefits: [2] }
};

export const plansBrasilAdmVida = {
	'YALO Vida': { benefits: [2, 3] }
};

export const plansBrasilAdmFidelidade = {
	'YALO Fidelidade': { benefits: [2, 3, 4, 5] }
};

export const plansTheNail = {
	'YALO Fidelidade': { benefits: [1, 2, 3, 7, 8] }
};

export const plansCaarj = {
	'YALO e-MED': { benefits: [2] },
	'YALO Vida': { benefits: [2, 3] }
};

export const plansMarisa = {
	'YALO Fidelidade': { benefits: [1, 2, 3, 7, 8] }
};
export const plansBrasilAdm = {
	'YALO Saude': { benefits: [2, 3, 4, 5, 6, 7, 8] }
};

/**
 * Box 1 [dr.consulta] Consulta presencial [benefits.2] e online [benefits.7] e 20% de desconto em exames [benefits.3]
 * Box 2 [drogaraia] 60% de desconto em medicamentos genéricos tarjados e muito mais! [benefits.5]
 * Box 3 [smartfit] Você paga apenas R$ 39,90 na Smart Fit, além de ter descontos diferenciados em outras academias da TotalPass [benefits.4]
 * Box 4 [drogaraia] 15% de desconto em medicamentos tarjados, genéricos e de marca [!benefits.5 && benefits.1]
 */

// para mostrar os boxes
const benefitsStore = {
	yalo: [1, 2, 3, 4, 5, 6, 7, 8]
};

/**
 * Banner propaganda do plano
 * plan.name [seleciona o plano mais caro] valor do plano [seleciona a maior quantidade de vezes da loja]
 */

/** raiaBannerTitle = 'Economize em mais de 2.000 farmácias' */

const raiaBenefitsTexts = {
	1: { title: '60%', text: 'de desconto em medicamentos genéricos tarjados' },
	2: {
		title: '35%',
		text: 'de desconto em medicamentos genéricos isentos de prescrição'
	},
	3: {
		prefixTitle: 'Até',
		title: '25%',
		text: 'de desconto em medicamentos de marca'
	},
	4: { title: '5%', text: 'de desconto no setor de perfumaria' },
	5: {
		title: '15%',
		text: 'de desconto em medicamentos tarjados, genéricos e de marca'
	}
};

// key benefits.id value raiaBenfitsTexts
const benefitsPharma = {
	1: [5],
	5: [1, 2, 3, 4]
};
